import { AdditionalInfoSectionType } from 'modules/Appointments/VisualGuide/components/AdditionalInfoSection';
import { InfoSectionType } from 'modules/Appointments/VisualGuide/components/InfoSection';
import { BbookingStepsType, VisaulGuideStepItemType } from 'modules/Appointments/VisualGuide/types';

import bookSlotSrc from '@common/assets/images/appointments-visual-guide/book-slot.webp';
import selectTeacherSrc from '@common/assets/images/appointments-visual-guide/select-teacher.webp';
import selectWeekSrc from '@common/assets/images/appointments-visual-guide/academy-select-week.png';

export const VISUAL_GUIDE_STEPS: VisaulGuideStepItemType[] = [
	{
		step: 1,
		title: 'appointment.visualGuide.selectTeacher',
		imageSrc: selectTeacherSrc,
		altImageName: 'selectTeacher',
	},
	{
		step: 2,
		title: 'appointment.visualGuide.selectWeek',
		imageSrc: selectWeekSrc,
		altImageName: 'selectWeek',
	},
	{
		step: 3,
		title: 'appointment.visualGuide.bookSlot',
		imageSrc: bookSlotSrc,
		altImageName: 'bookSlot',
	},
];

export const INFO_SECTION: InfoSectionType = {
	sectionDescription: 'appointment.visualGuide.sectionDescription',
	usefulInfo: 'appointment.visualGuide.usefulInfo',
	sessionDuration: 'appointment.visualGuide.sessionDuration',
	sessionFormat: 'appointment.visualGuide.sessionFormat',
};

export const STEP_SECTION: BbookingStepsType = {
	bookingSteps: 'appointment.visualGuide.bookingSteps',
};

export const ADDITIONAL_INFO_SECTION: AdditionalInfoSectionType = {
	note: 'appointment.visualGuide.note',
	bookingRestriction: 'appointment.visualGuide.bookingRestriction',
	sessionLinkInfo: 'appointment.visualGuide.sessionLinkInfo',
};
